import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { GlobalProvider } from '../../providers/global/global';
import { ConfirmPage } from '../confirm/confirm';
import { Tab2Page } from '../tab2/tab2';
import { HttpParams,  HttpClient } from '@angular/common/http';
import { AlertController } from 'ionic-angular';
import { TimesheetlistPage } from '../../pages/timesheetlist/timesheetlist';
import { ConfirmType1Page } from '../../pages/confirm-type1/confirm-type1';
import { ConfirmType1MonthlyPage } from '../../pages/confirm-type1-monthly/confirm-type1-monthly';
import { ExpensesPage } from '../expenses/expenses';
import { RequestsProvider } from '../../providers/requests/requests';
import { PopoverController } from 'ionic-angular';
import { PopoverPage } from '../popover/popover';


/**
 * Generated class for the TimesheetType3Page page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-timesheet-type3',
  templateUrl: 'timesheet-type3.html',
})
export class TimesheetType3Page {

  today;
  dt1: any;
  minhours: number;
  maxhours: number;

  dt1table1:any;
  dt1table2:any;
  dt1table3:any;
  dt1table4:any;

  dt2table1:any;
  dt2table2:any;
  dt2table3:any;
  dt2table4:any;

  time ;
  day;
  //overtime;
  newMin: string ;
  newMax: string ;
  interval: number;
  minuteItervals: Array<number>;
  minuteItervalsString: string;
  hourInterval: Array<number>
  hourItervalsString: string;

  res2: any;
  grid2: string;
  save_res: string;
  save_data: any;
  dt2: any;
  tab2id: string;
  res1: any;
  quantity6: string;
  quantity7: string;

  iRow: number;
  jDay: number;
  checkexpenses : boolean = true;
  tab2index: number;

  constructor(public http: HttpClient, public global: GlobalProvider,public navCtrl: NavController,
    public navParams: NavParams, private alertCtrl: AlertController ,public requests:RequestsProvider, public popoverCtrl: PopoverController) {

      //debugger
      // this.global.shownGroup = 0;
      this.tab2id = this.navParams.get('TAB2ID');
      this.tab2index = this.navParams.get('TAB2Index');
      //console.log('tab2idarray: ' + this.global.TAB2id);
      //console.log('tab2idarray: ' + this.global.TAB2id[this.global.ndaysIndex-1]);

  }

  presentPopover(myEvent) {
    let popover = this.popoverCtrl.create(PopoverPage);
    popover.present({
      ev: myEvent
    });
  }

  autofillClick(){
    if(this.requests.TimesheetAutofillReceived.observers.length==0){
      this.requests.TimesheetAutofillReceived.subscribe(
        () => {
          //console.log('Auto Fill Done.......... : ' );
          this.confirmClick();
          // this.global.tab2index = this.global.ndays - 1;
          //this.navCtrl.push(TimesheetType3Page, {TAB2ID: this.global.TAB2id[this.global.tab2index]});
          
        }
      );
    }
    var date="";
    if(this.global.timesheettype == '3'){
      var table = [];

      if(this.global.grid1Visibility) 
        table = JSON.parse(this.global.dt_grid1[0]);
      else if(this.global.grid2Visibility) 
        table = JSON.parse(this.global.dt_grid2[0]);

      if(table.length) 
        date = table[0]['Quantity' + String(this.global.ndaysIndex)];

    } else if(this.global.timesheettype == '1') {
      date = this.global.TAB2id[this.global.tab2index];
    }

    this.requests.httpRequestAutoFill(date);
  }

  nextClick() {

    //debugger
    this.global.shownGroup = null;
    // this.global.shownGroup = 0;

    this.global.ndaysIndex++;     //for type 3
    this.global.tab2index++;      //for type 1

    this.global.skiptab2 = false; ////added20240916 to prevent issue if user press prev then next on one day timesheets
    
    if(this.global.timesheettype == '3' ){
      
      if ((this.global.ndaysIndex < 1 || this.global.ndaysIndex > this.global.ndays )){
          

        if(this.checkexpenses && this.global.TAB2id[this.global.TAB2id.length - 1].trim() == "EXPENSES2"){
          this.checkexpenses = false;
          this.global.ndaysIndex--;
          this.httpRequestExpenses_read();
        } else {
          this.global.ndaysIndex--;
          this.goToConfirm();
        }

      } 
    }
// 
    else if(this.global.timesheettype == '1' && this.global.TAB2id[this.global.tab2index].trim() != "EXPENSES2" ){
      
      if ((this.global.tab2index < 0 || this.global.tab2index > this.global.ndays - 1)){

        this.global.tab2index--;
        this.goToConfirm();
      }
      else {
        this.httpRequestGrid1_read('timeentry');
      }

    }   

    if( this.global.timesheettype == '1' && this.global.TAB2id[this.global.tab2index]){
      //check if this index exists in tab2 first
      //then check if it's expenses  
      if(this.global.TAB2id[this.global.tab2index].trim() == "EXPENSES2"){
        this.global.tab2index--;
        this.httpRequestExpenses_read();
      }
    }

    if( this.global.timesheettype == '3' && this.global.TAB2id[this.global.ndaysIndex]){
      //check if this index exists in tab2 first
      //then check if it's expenses  
      //temp to check this for non monthly timesheets (to fix next on all days)
      if(this.global.TAB2id[this.global.ndaysIndex].trim()=="EXPENSES2" && this.global.TimesheetPeriod != 1){
        this.global.ndaysIndex--;
        this.httpRequestExpenses_read();
      }
    }
    

  }

  prevClick() {

    this.global.shownGroup = null;
    // this.global.shownGroup = 0;

    this.global.ndaysIndex--;
    this.global.tab2index--;

    if(this.global.timesheettype=='3'){
      if ((this.global.ndaysIndex < 1 || this.global.ndaysIndex > this.global.ndays)) {

        if(this.global.dt2.length < 2){

          this.global.skiptab2 =true;
          this.global.ndaysIndex++;
          //this.global.tab2index++;
          this.navCtrl.push(TimesheetlistPage);
        }

        else {
          this.global.skiptab2 =false;
          this.global.ndaysIndex++;
          //this.global.tab2index++;
          //this.httpRequestTab2();
          this.navCtrl.push(Tab2Page);
        }

      }

    }

    else if(this.global.timesheettype == '1'){
      //debugger;
      if ((this.global.tab2index < 0 || this.global.tab2index > this.global.ndays - 1 )) {

        if(this.global.dt2.length < 2){
          this.global.skiptab2 =true;
          //this.global.ndaysIndex++;
          this.global.tab2index++;
          this.navCtrl.push(TimesheetlistPage);
        }
        else {
          this.global.skiptab2 =false;
          //this.global.ndaysIndex++;
          this.global.tab2index++;
          //this.httpRequestTab2();
          this.navCtrl.push(Tab2Page,{reload:1});
        }
      }

      else {
        this.httpRequestGrid1_read('timeentry');
      }
    }

  }

  httpRequestGrid1_read(next: string){

    //debugger;
    this.global.createLoader();
    this.global.loading.present().then((result) => {

    var p:any={};
    p.timesheetid = this.global.timesheetid;
    p.timesheettype = this.global.timesheettype;
    p.contacttype = this.global.contacttype;
    
    if (this.global.timesheettype =='1'){
      p.id = this.global.TAB2id[this.global.tab2index];
    } else {
      //p.id = this.global.TAB2id[this.global.ndaysIndex-1];
      p.id = this.tab2id;
    }
    p.entity = 'GRID1';

    const params = new HttpParams()
.set('j',JSON.stringify(p))


    this.http.post('timesheets/timesheet_read/',params).subscribe(

      (data) => {

        this.global.loading.dismiss();

          this.res1 = data;
          if(this.res1.result==true) {

            this.global.dt_grid1 = JSON.parse(this.res1.dt);
            this.global.dt1table1 = JSON.parse(this.global.dt_grid1[0]);

            if(this.global.timesheettype=='1'){
              this.resolve_grid1_t1();
            }
            //this.global.grid1Visibility=true;

            this.global.grid1Visibility = true;
            this.httpRequestGrid2_read(next);

          }
          else {
            this.global.grid1Visibility = false;

            this.httpRequestGrid2_read(next);

          }

      },
      error => {
        alert('error');
      }
    );

  }).catch((err) => {

  });


  }

  resolve_grid1_t1() {
    //default is what the picker opens to
    //start/end/break is what is displayed on screen
    //always display start/end/break
    //if start/break/end are zero - open to default , else open to start/break/end
    //should read based on timeinputcontrol , but always save as 24 hours
    for(var i = 0; i < this.global.dt1table1.length; i++) {
      
      if(this.global.TimeInputControl == '24') {
        this.global.dt1table1[i]['StartTime'] = this.t_convert_ampm_to_24(this.global.dt1table1[i]['StartTime']);
        this.global.dt1table1[i]['FinishTime'] = this.t_convert_ampm_to_24(this.global.dt1table1[i]['FinishTime']);
      }

      if(this.global.dt1table1[i]['StartTime'] != "00:00 AM" && this.global.dt1table1[i]['StartTime'] != "00:00"){
        this.global.dt1table1[i]['DefaultStartTime'] = this.global.dt1table1[i]['StartTime'];
      }
      if(this.global.dt1table1[i]['FinishTime'] != "00:00 AM" && this.global.dt1table1[i]['FinishTime'] != "00:00"){
        this.global.dt1table1[i]['DefaultEndTime'] = this.global.dt1table1[i]['FinishTime'];
      }
      if(this.global.dt1table1[i]['BreakTime'] != "00:00 AM" && this.global.dt1table1[i]['BreakTime'] != "00:00"){
        this.global.dt1table1[i]['DefaultBreakTime'] = this.global.dt1table1[i]['BreakTime'];
      }

      this.global.dt1table1[i]['DefaultStartTime'] = this.t_convert_ampm_to_24(this.global.dt1table1[i]['DefaultStartTime']); 
      this.global.dt1table1[i]['DefaultEndTime'] = this.t_convert_ampm_to_24(this.global.dt1table1[i]['DefaultEndTime']); 
    }  
  }
  
  
  t_convert_ampm_to_24(t:string){
    if(t.includes("AM")||t.includes("PM")){
      var time = t;
      var hours = Number(time.match(/^(\d+)/)[1]);
      var minutes = Number(time.match(/:(\d+)/)[1]);
      var AMPM = time.match(/\s(.*)$/)[1];
      if(AMPM == "PM" && hours<12) hours = hours+12;
      if(AMPM == "AM" && hours==12) hours = hours-12;
      var sHours = hours.toString();
      var sMinutes = minutes.toString();
      if(hours<10) sHours = "0" + sHours;
      if(minutes<10) sMinutes = "0" + sMinutes;
      return (sHours + ":" + sMinutes);}
    else {
      return t;
    }
  }


  httpRequestGrid2_read(next: string){

    var p:any={};
    p.timesheetid = this.global.timesheetid;
    p.timesheettype = this.global.timesheettype;
    p.contacttype = this.global.contacttype;
    
    //p.id = this.tab2id;
    //p.id = this.global.TAB2id[this.global.ndaysIndex-1];
    if (this.global.timesheettype =='1'){
      p.id = this.global.TAB2id[this.global.tab2index];
    } else {
      //p.id = this.global.TAB2id[this.global.ndaysIndex-1];
      p.id = this.tab2id;
    }
    p.entity = 'GRID2';


    const params = new HttpParams()
    .set('j',JSON.stringify(p))


    this.http.post('timesheets/timesheet_read/',params).subscribe(

      (data) => {

        this.res2 = data;
        if(this.res2.result==true)
        {
          //console.log('2: ' + this.res2);
          this.global.dt_grid2 = JSON.parse(this.res2.dt);
          this.global.dt2table1 = JSON.parse(this.global.dt_grid2[0]);
          this.global.grid2Visibility = true;

          this.global.setGrid2Option();


          //debugger;
          if(this.global.skiptab2 == true){
            this.navCtrl.push(TimesheetlistPage);
          }
          else{
            if(next == "confirm"){
              this.httpRequest_totalexpenses();
              // this.navCtrl.push(ConfirmPage);
            }
            else if(next == "confrimtype1"){
              this.navCtrl.push(ConfirmType1Page);
            }
            else if(next == "timeentry"){

              //debugger;
              //this.navCtrl.push(TimesheetType3Page);

            }
          }


        }

        else {
          this.global.grid2Visibility = false;

          //debugger;
          if(this.global.skiptab2 == true){
            this.navCtrl.push(TimesheetlistPage);
          }
          // else{
          //   this.navCtrl.push(ConfirmPage);
          // }

          else{
            if(next == "confirm"){
              this.httpRequest_totalexpenses();
              //this.navCtrl.push(ConfirmPage);
            }
            else if(next == "timeentry"){
              // this.global.shownGroup = 0;
              //debugger;
              //this.navCtrl.push(TimesheetType3Page);

            }
          }

        }

      },
      error => {
        alert('error');
      }
    );

  }


  httpRequestTab2(){

    // this.global.createLoader();
    // this.global.loading.present().then((result) => {


    //this.flag = true;
        //debugger;
        var p:any={};
        p.timesheetid = this.global.timesheetid;
        p.timesheettype = this.global.timesheettype;
        p.contacttype = this.global.contacttype;
        p.id = this.global.id;
        p.entity = 'TAB2';

        const params = new HttpParams()
        .set('j',JSON.stringify(p))


        this.http.post('timesheets/timesheet_read/',params).subscribe(
          (data) => {
            //this.flag = false;

            this.res2 = data;
            var r = JSON.parse(this.res2.dt)
          
            if(this.res2.result == true){
              
              var dt2 = JSON.parse(this.res2.dt);
              this.global.dt2 = JSON.parse(dt2[0]);
              //console.log('len: ' + this.global.dt2.length);

              this.global.TAB2Caption=[];
              this.global.TAB2id = [];
              this.global.TAB2TotalTime=[];
              for(var i = 0; i < this.global.dt2.length; i++){
                // debugger
                this.global.TAB2Caption[i] = this.global.dt2[i]['Caption'];
                this.global.TAB2id[i] = this.global.dt2[i]['ID'];
                this.global.TAB2TotalTime[i] = this.global.dt2[i]['TotalTime'];
                
              }
              this.navCtrl.pop();
              // this.caption = this.global.TAB2Caption;
              // this.totaltimearray = this.global.TAB2TotalTime;
              // console.log(this.caption);

              // console.log(this.global.TAB2id);
              // this.global.ndays = this.global.TAB2id.length - 2;

          }
          else {
            // this.global.loading.dismiss();
            //this.httpRequestGrid1_read();
          }


          },
          error => {alert('error');}
        );

    }
  

  //Custom Back to close the expandable
  back_button() {
    this.global.shownGroup = null;
    this.httpRequestTab2();
    
  }


  goToConfirm() {


    if(this.global.timesheettype == '3'){
      //this.httpRequestGrid1_read('confirm');
      if(this.global.TimesheetPeriod == 1){
        //monthly
        this.httpRequest_totalmonthly();
      } else {
        this.httpRequestGrid1_read('confirm');
      }
    }
    else if(this.global.timesheettype == '1'){

     

      if(this.global.TimesheetPeriod == 1){
        //monthly
        this.httpRequest_totalmonthly();
      } else {
        this.httpRequest_totalgrid1();
      }
      
    }

  }

  confirmClick(){

    if(this.global.timesheettype=='3'){
      this.goToConfirm();
    }
    else {
      //this.httpRequest_totalgrid1();
      if(this.global.TimesheetPeriod == 1){
        //monthly
        this.httpRequest_totalmonthly();
      } else {
        this.httpRequest_totalgrid1();
      }
      
    }
    
  }

  httpRequest_totalmonthly(){

    this.global.createLoader();
    this.global.loading.present().then((result) => {

    var p:any={};
    //p.sp_name = "sp_timesheet1_totals";
    p.timesheetid = this.global.timesheetid;

    const params = new HttpParams()
    .set('j',JSON.stringify(p))

    this.http.post('timesheets/timesheet_read_monthly_totals/',params).subscribe(

      (data) => {

        //debugger;
        

          var res1: any = data;
          if (res1.result == true) {

            this.global.dt_grid1 = JSON.parse(res1.dt);
            //this.navCtrl.push(ConfirmType1MonthlyPage);
            this.httpRequest_totalexpenses();
            this.global.grid1Visibility=true;

            //this.global.grid1Visibility = true;
            //this.httpRequest_totalgrid2();

          }
          else {
            this.global.dt_grid1 = [];
            this.httpRequest_totalexpenses();
            this.global.grid1Visibility=false;
            //this.httpRequest_totalgrid2();
          }

      },
      error => {
        alert('error');
      }
    );

  }).catch((err) => {

  });


  }

  httpRequest_totalgrid1(){

    this.global.createLoader();
    this.global.loading.present().then((result) => {

    var p:any={};
    p.timesheetid = this.global.timesheetid;
    p.timesheettype = this.global.timesheettype;
    p.contacttype = this.global.contacttype;
    p.id = 'TOTALS2';
    p.entity = 'TOTALS2GRID1';

    const params = new HttpParams()
    .set('j',JSON.stringify(p))


    this.http.post('timesheets/timesheet_read/',params).subscribe(

      (data) => {

        //debugger;
        

          var res1: any = data;
          if (res1.result == true) {

            this.global.dt_grid1 = JSON.parse(res1.dt);

            //this.global.grid1Visibility=true;

            this.global.grid1Visibility = true;
            this.httpRequest_totalgrid2();

          }
          else {
            this.global.grid1Visibility = false;
            this.httpRequest_totalgrid2();
          }

      },
      error => {
        alert('error');
      }
    );

  }).catch((err) => {

  });


  }

  httpRequest_totalgrid2(){

    //debugger;
    var p:any={};
    p.timesheetid = this.global.timesheetid;
    p.timesheettype = this.global.timesheettype;
    p.contacttype = this.global.contacttype;
    //p.id = this.tab2id;
    //p.id = this.global.TAB2id[this.global.ndaysIndex-1];
    p.id = 'TOTALS2';
    p.entity = 'TOTALS2GRID2';


    const params = new HttpParams()
    .set('j',JSON.stringify(p))


    this.http.post('timesheets/timesheet_read/',params).subscribe(

      (data) => {

        //debugger;
        var res2: any = data;

        if(res2.result==true)
        {
          //console.log('2: ' + this.res2);
          this.global.dt_grid2 = JSON.parse(res2.dt);
          //console.log(this.global.dt_grid2);
          this.global.grid2Visibility = true;
          this.httpRequest_totalexpenses();
          
        }
        else {

          this.global.grid2Visibility = false;
          this.httpRequest_totalexpenses();


        }
      },
      error => {
        alert('error');
      }
    );

  }
  
 httpRequest_totalexpenses(){
  // this.global.createLoader();
  // this.global.loading.present().then((result) => {

    var p:any={};
    p.timesheetid = this.global.timesheetid;
    p.contacttype = this.global.contacttype;
    p.timesheetentriesid = '0';
    p.userid = '0';

    const params = new HttpParams()
    .set('j',JSON.stringify(p))


    this.http.post('timesheets/expenses_read/',params).subscribe(

      (data) => {

        this.global.loading.dismiss();
        var resexpenses: any = data;
        if (resexpenses.result == true) {
          
          // var dt_expenses_total = JSON.parse(resexpenses.dt);
          this.global.dt_expenses = JSON.parse(resexpenses.dt);
          this.global.dt_expenses_total_confirm = JSON.parse(this.global.dt_expenses[0]);
          // debugger
          // console.log(JSON.parse(this.global.dt_expenses[1]))

          //IN CASE THERE ARE NO EXPENSES ENTERED, THIS ROW IS EMPTY
          //THEREFORE THE EXPENSES DONT APPEAR IN TOTALS PAGE
          //THAT'S WHY WE ADD THIS ROW
          if (this.global.dt_expenses_total_confirm.length == 0 ){
            this.global.dt_expenses_total_confirm.push({
                'Miles':0,
                'MilesAmount' : 0,
                'TotalExpenses': 0,
                'GrandTotal': 0,
                'MilageRate' : JSON.parse(this.global.dt_expenses[1])[0].Mileage })
          }

          for (var key in this.global.dt_expenses_total_confirm[0]) {
            var v = this.global.dt_expenses_total_confirm[0][key];
            //v = v.toFixed(2);
            if (key=="MilageRate") v= v.toFixed(4);
            else v = v.toFixed(2);
            this.global.dt_expenses_total_confirm[0][key] = v;
          }
      
          //BECAUSE THIS ALWAYS RETURNS DATA
          //DECIDE IF THERE IS EXPENSES FROM TAB2ID
          for(var x = 0; x < this.global.TAB2id.length; x++){
            if (this.global.TAB2id[x].trim() == "EXPENSES2"){
              
              this.global.expensesVisibility = true;
              break;

            } else {
              
              this.global.expensesVisibility = false;

            }
          }
          // this.TotalsReceived.next();
          //console.log('Total Data Received.......... : ' );
          if( this.global.timesheettype == '1') {
            if(this.global.TimesheetPeriod == 1){
              this.navCtrl.push(ConfirmType1MonthlyPage);
            } else{
              this.navCtrl.push(ConfirmType1Page);
            }
          } else if (this.global.timesheettype=='3'){
            this.navCtrl.push(ConfirmPage);
          }
          
        } else {

          this.global.expensesVisibility = false;
          //console.log('Total Data Received.......... : ' );
          //this.navCtrl.push(ConfirmType1Page);
          if( this.global.timesheettype == '1') {

            if(this.global.TimesheetPeriod == 1){
              this.navCtrl.push(ConfirmType1MonthlyPage);
            } else{
              this.navCtrl.push(ConfirmType1Page);
            }
          } else if (this.global.timesheettype=='3'){
            this.navCtrl.push(ConfirmPage);
          }
          // this.TotalsReceived.next();
        }
        
      },
      error => {
        alert('error');
      }
    );

  // }).catch((err) => {

  // });
 }
  httpRequestExpenses_read(){
  this.global.createLoader();
  this.global.loading.present().then((result) => {

    var p:any={};
    p.timesheetid = this.global.timesheetid;
    p.contacttype = this.global.contacttype;
    p.timesheetentriesid = '0';
    p.userid = '0';

    const params = new HttpParams()
    .set('j',JSON.stringify(p))


    this.http.post('timesheets/expenses_read/',params).subscribe(

      (data) => {
        //debugger

        this.global.loading.dismiss();
        var resexpenses: any = data;
        if (resexpenses.result == true) {
          this.global.dt_expenses = JSON.parse(resexpenses.dt);
          this.httpRequestExpenses_ddl_read();
          
        }
        
      },
      error => {
        alert('error');
      }
    );

  }).catch((err) => {

  });


}

httpRequestExpenses_ddl_read(){
  //this.global.createLoader();
  //this.global.loading.present().then((result) => {

  var p:any = {};
  //p.sp_name = "sp_expense_types_ddl";
  p.timesheetid = this.global.timesheetid;
  p.timesheetentriesid = '0';

  const params = new HttpParams()
  .set('j',JSON.stringify(p))


  this.http.post('timesheets/expenses_ddl_read/',params).subscribe(

    (data) => {
      //debugger

      //this.global.loading.dismiss();
      var resexpenses_ddl : any = data;
      if (resexpenses_ddl.result == true) {
        //debugger
        this.global.dt_expenses_ddl = JSON.parse(resexpenses_ddl.dt);
        this.navCtrl.push(ExpensesPage);
      }
      
    },
    error => {
      alert('error');
    }
  );

// }).catch((err) => {

// });

}



  goToTab2()
  {
    this.navCtrl.push(Tab2Page);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad TimesheetType3Page');
    
    
  }

}



// WEBPACK FOOTER //
// ./src/pages/timesheet-type3/timesheet-type3.ts